import React, { useState, useEffect } from "react";
import { Table, Spin, DatePicker } from 'antd';
import Spinner from '../../components/spinner';
import styles,* as Styled from './style.js';
import moment from 'moment';
import { getData } from '../../config/api-connect';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Button, Modal } from 'antd';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
} from '../../config/api-connect';
import { ArrowRightOutlined } from '@ant-design/icons';
import { getCurrentFinancialYear } from '../../utils/helper';



const { RangePicker } = DatePicker;

const Leaves = () => {
  const [leaveData, setLeaveData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState(getCurrentFinancialYear());
  const [searchText, setSearchText] = useState('');
  const [summary, setSummary] = useState({});
  const [applications, setApplications] = useState([]);
  const [showLeaves, setShowLeaves] = useState(false);
  const [leaves, setLeaves] = useState([]);
  const [pending, setPending] = useState([]);
  const [approved, setApproved] = useState([]);
  const [rejected, setRejected] = useState([]);
  const [summaryLoader, setSummaryLoader] = useState(false)
  const [expandedCities, setExpandedCities] = useState({});
  const [newshowLeaves, setNewShowLeaves] = useState(false);
	const [buddyLeaves, setBuddyLeaves] = useState([]);
	const [leavesLoading, setLeavesLoading] = useState(false);
	const [totalLeaves, setTotalLeaves] = useState()



  useEffect(() => {
    fetchLeaveData();
    getApplications()
  }, [dateRange]);

  const fetchLeaveData = () => {
	  setLoading(true);

	  const [startMoment, endMoment] = dateRange;
	  const start_date = startMoment.format('YYYY-MM-DD');
	  const end_date = endMoment.format('YYYY-MM-DD');

	  let url = `/finance/get_leaves_data/?status=All`;

	  if (start_date && end_date) {
	    url += `&start_date=${start_date}&end_date=${end_date}`;
	  }

	  getData(url)
	    .then((response) => {
	      if (response?.success && Array.isArray(response.data)) {
	        const formattedData = response.data.map((item, index) => ({
	          key: index,
	          buddy_id: item.buddy_id,
	          employee: item.name || 'N/A',
	          mobile_no: item.mobile_no || 'N/A',
	          department: item.department || 'N/A',
	          role: item.role || 'N/A',
	          vacation: item.vacation || 0,
	          personal: item.personal || 0,
	          sick: item.sick || 0,
	          total_leaves_taken: item.total_leaves_taken || 0,
	          cities: Array.isArray(item.cities) ? item.cities : [],
	        }));

	        setLeaveData(formattedData);
	      } else {
	        setLeaveData([]);
	      }

	      setLoading(false);
	    })
	    .catch((error) => {
	      console.error("Fetch error:", error.message);
	      setLoading(false);
	    });
	};

	const getBuddyLeaves = (record) => {
	  if (!record.buddy_id) {
	    console.error("Buddy ID is missing for this record.");
	    return;
	  }

	  setLeavesLoading(true);
	  setNewShowLeaves(true);
	 	setTotalLeaves(record.total_leaves_taken)

	  const [startMoment, endMoment] = dateRange;
	  const start_date = startMoment.format('YYYY-MM-DD');
	  const end_date = endMoment.format('YYYY-MM-DD');

    let url = `/buddy/get_buddy_leaves/?buddy_id=${record.buddy_id}`;

    if (start_date && end_date) {
      if(start_date > end_date) {
        alert('Start date must be less than end date !')
        return;
      }
      url += `&start_date=${start_date}&end_date=${end_date}`;
    }

	  getData(url)
	    .then((response) => {
	      console.log("Buddy Leaves API Response:", response);

	      if (response?.success && Array.isArray(response.leaves_data)) {
	        setBuddyLeaves(response.leaves_data);
	      } else {
	        setBuddyLeaves([]);
	      }

	      setLeavesLoading(false);
	    })
	    .catch((error) => {
	      console.error("Fetch error:", error.message);
	      setLeavesLoading(false);
	    });
	};

	const toggleCities = (key) => {
	  setExpandedCities((prev) => ({
	    ...prev,
	    [key]: !prev[key]
	  }));
	};

	const getApplications = () => {
	  setLoading(true);
	  setSummaryLoader(true)
	  const [startMoment, endMoment] = dateRange;
	  const start_date = startMoment ? startMoment.format('YYYY-MM-DD') : '';
	  const end_date = endMoment ? endMoment.format('YYYY-MM-DD') : '';

	  let url = `/buddy/get_leave_applications_for_admin/?status=All`;

	  if (start_date && end_date) {
	    url += `&start_date=${start_date}&end_date=${end_date}`;
	  }

	  getData(url)
	    .then((response) => {
	      if (response?.success && Array.isArray(response.data)) {
	        setApplications(response.data);
	        setData(response.data);
	        setSummaryLoader(false)
	      } else {
	        setApplications([]);
	        setData([]);
	      }
	      setLoading(false);
	    })
	    .catch((error) => {
	      console.error("Fetch error:", error.message);
	      setLoading(false);
	    });
	};



	const setData = (applications) => {
	  if (applications) {
	    const pendingList = applications.filter((x) => x.status === 'Leave Applied');
	    const approvedList = applications.filter((x) => x.status === 'Leave Approved');
	    const rejectedList = applications.filter((x) => x.status === 'Leave Rejected');

	    setPending(pendingList);
	    setApproved(approvedList);
	    setRejected(rejectedList);
	    setLoading(false);
	  } else {
	    setLoading(false);
	  }
	};

	const filteredData = leaveData.filter((item) =>
	  Object.values(item).some((val) =>
	    String(val).toLowerCase().includes(searchText.toLowerCase())
	  )
	);


  const columns = [
    { title: 'Employee', dataIndex: 'employee', key: 'employee' },
    { title: 'Mobile No', dataIndex: 'mobile_no', key: 'mobile_no' },
    { title: 'Department', dataIndex: 'department', key: 'department' },
    { title: 'Role', dataIndex: 'role', key: 'role' },
    {
    title: 'Cities',
    dataIndex: 'cities',
    key: 'cities',
    render: (cities, record) => {
      if (!Array.isArray(cities) || cities.length === 0) return 'N/A';

      const isExpanded = expandedCities[record.key];
      const displayCities = isExpanded ? cities : cities.slice(0, 3);
      return (
	        <div>
	          {displayCities.join(", ")}
	          {cities.length > 3 && (
	            <span
	              style={{ color: '#1890ff', cursor: 'pointer', marginLeft: 5 }}
	              onClick={() => toggleCities(record.key)}
	            >
	              {isExpanded ? " Read Less" : " ...Read More"}
	            </span>
	          )}
	        </div>
	      );
	    }
	  },
    { title: 'Vacation', dataIndex: 'vacation', key: 'vacation', align: 'center' },
    { title: 'Personal', dataIndex: 'personal', key: 'personal', align: 'center' },
    { title: 'Sick', dataIndex: 'sick', key: 'sick', align: 'center' },
    {
		  title: 'Total Leaves Taken',
		  dataIndex: 'total_leaves_taken',
		  key: 'total_leaves_taken',
		  align: 'center',
		  render: (text, record) => (
		    <span
		      className='venueTitle' style={{cursor: 'pointer'}}
		      onClick={() => getBuddyLeaves(record)}
		    >
		      {text}
		    </span>
		  ),
		}

  ];


  return (
    <Spin spinning={loading} indicator={<Spinner />}>
    <Modal
	  open={newshowLeaves}
	  onCancel={() => setNewShowLeaves(false)}
	  footer={null}
	  width={600}
		>
		  <div style={{ textAlign: "center", marginBottom: 16 }}>
		    <h3>Leaves History</h3>
		  </div>
		  <div style={{padding:'5px',fontWeight:'600',textAlign:'center'}}>Total Leaves Taken - {totalLeaves}</div>

		  {leavesLoading ? (
		    <div style={{ height: 300, display: "flex", justifyContent: "center", alignItems: "center" }}>
		      <Spin />
		    </div>
		  ) : buddyLeaves.length > 0 ? (
		    <Table
		      dataSource={buddyLeaves.map((x, idx) => ({
		        key: idx,
		        date: moment(x.leave_date).format("MMM DD, YYYY"),
		        type: x.leave_type_str,
		      }))}
		      columns={[
		        { title: "Date", dataIndex: "date", key: "date", align: "center" },
		        { title: "Type", dataIndex: "type", key: "type", align: "center" },
		      ]}
		      pagination={false}
		      bordered
		    />
		  ) : (
		    <div style={{ textAlign: "center", fontWeight: "bold", padding: 20 }}>
		      No Leaves Taken
		    </div>
		  )}
		</Modal>
      <Styled.MainContainer>
        <Styled.Header>
        	<a></a>
          <div>
            Leave Management
          </div>
          <a></a>
        </Styled.Header>
        <div
		  style={{
		    display: "flex",
		    justifyContent: "space-between",
		    alignItems: "center",
		    marginTop:"12px",
		    marginBottom: "16px",
		    gap: "12px",
		  }}
		>
		  <RangePicker
		    value={dateRange}
		    onChange={(dates) => setDateRange(dates || [])}
		    format="DD-MM-YYYY"
		    allowClear={false}
		  />
		  
		  <Input
		    placeholder="Search..."
		    prefix={<SearchOutlined />}
		    value={searchText}
		    onChange={(e) => setSearchText(e.target.value)}
		    style={{ width: "250px" }}
		    allowClear
		  />
		</div>

        <div className='row' style={{ margin: '5px' }}>

            {summaryLoader ?
              <div style={{ height: '25vh',display: 'flex',alignItems: 'center',justifyContent: 'center' }}>
                <Spin />
              </div>
            :
		    <div className='col-md-12 col-xs-12' 
			     style={{ padding: '10px', background: '#fff', borderRadius: '10px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', display: 'flex', flexDirection: 'column' }}>
			  <div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap' }}>
			    <div style={styles.statsBlock}>
			      <div style={{ ...styles.statCircle, backgroundColor: '#3397AD' }}>
			        {applications.length}
			      </div>
			      <div style={styles.statLabel}>Total Requests</div>
			    </div>

			    <div style={styles.statsBlock}>
			      <div style={{ ...styles.statCircle, backgroundColor: '#62bf65' }}>
			        {approved.length}
			      </div>
			      <div style={styles.statLabel}>Approved</div>
			    </div>

			    <div style={styles.statsBlock}>
			      <div style={{ ...styles.statCircle, backgroundColor: '#d9aa68' }}>
			        {pending.length}
			      </div>
			      <div style={styles.statLabel}>Pending</div>
			    </div>

			    <div style={styles.statsBlock}>
			      <div style={{ ...styles.statCircle, backgroundColor: '#cf5f73' }}>
			        {rejected.length}
			      </div>
			      <div style={styles.statLabel}>Rejected</div>
			    </div>
			  </div>
			  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
			    <Link to={`/leaveApplications/?start_date=${dateRange[0].format('YYYY-MM-DD')}&end_date=${dateRange[1].format('YYYY-MM-DD')}`}>
			      <Styled.ViewMoreButton>    
			        View Leave Applications
			        <ArrowRightOutlined style={{ fontSize: 'large', cursor: 'pointer', marginLeft: '5px' }}/>
			      </Styled.ViewMoreButton>   
			    </Link>  
			  </div>
			</div>
		  }
		</div>


        <div className="recordCount">{leaveData.length} records</div>

        <Table
          className="ant-table-thead table_container"
          // tableLayout="fixed"
          dataSource={filteredData}
          columns={columns}
          pagination={{ pageSize: 100, showSizeChanger: false }}
        />
      </Styled.MainContainer>
    </Spin>


  );
};

export default Leaves;
